import mergeNotes from './mergeNotes'

function mergeNote(existingNote, newNote) {
  return mergeNotes([existingNote], [newNote])?.[0]
}

export default mergeNote
